<template lang="pug">
main.transfer-form-wrapper(:class="{'form-transfer-builder': this.parent === 'builder'}")

    div.modal-body.modal-content-transfer

        //- Select type of transfer : media or pixel
        div.form-section.big(:class="{'mg-tp-24': this.parent === 'builder'}")
            div.form-subsection-row.form-subsection-technology(
                :key="totalTransfers + 1"
                :class="{'no-option': !showMediaPlatformPanel || !showPixelUrlPanel}")
                label.radio-item(
                    v-if="showMediaPlatformPanel"
                    for="technology-media"
                    :class="technology === 'technology-media' ? 'is-active' : ''") Media Platform
                    input(
                        type="radio"
                        name="technology"
                        id="technology-media"
                        value="technology-media"
                        v-model="technology"
                        checked)
                label.radio-item(
                    v-if="showPixelUrlPanel"
                    for="technology-pixel"
                    :class="technology==='technology-pixel' ? 'is-active' : ''") Pixel URL
                    input(
                        type="radio"
                        name="technology"
                        id="technology-pixel"
                        value="technology-pixel"
                        v-model="technology")

        //- transfer label
        div.form-subsection
            div.form-label__required
                label Transfer Name
            input.form-input(
                id="transfer label"
                name="transfer label"
                v-model="transferData.label"
                placeholder="Transfer label"
                v-validate="'required|max:200|ascii'"
                @blur="handleResetFieldOnLeave('label')"
                type="text"
            )
            span.form-validate-error {{ errors.first('transfer label') }}

        //- date
        div.form-subsection
            div.form-label__required
                label End Date
            el-date-picker(
                v-model="endDate"
                name="end_date"
                class="datepicker"
                editable=true
                clearable=false
                type="date"
                :picker-options="endDateOptions"
                v-validate="'date_format:YYYY-MM-DD|required'"
                @blur="handleResetFieldOnLeave('endDate')"
                placeholder="Transfer end date")
        // div.form-subsection.w-180(v-if="!isFirstPartyInFormula")
            div.message-info
                svg-icon(name='circleInfo' size="large")
                div.message The furthest end date possible is 90 days due to the 3rd party only audience

        //- email
        div.form-subsection
            div.form-label__required
                label Email
            input.form-input(
                id="email_create_transfer"
                name="email"
                placeholder="user@weborama.com"
                v-model="transferData.email"
                v-validate="'max:255|required|email'"
                @blur="handleResetFieldOnLeave('email')"
                type="text"
            )
            span.form-validate-error {{ errors.first('email') }}

        //- cc
        div.form-subsection
            div.form-label.l-flex-row--between
                label Emails Cc
                div.counter(v-show="transferData.email_cc.length !== 0") {{transferData.email_cc.length }}/10
            EmailCcField(
                parent="FormCreateTransfer"
                placeholder="cc@weborama.com"
                :maxItems="10"
                :defaultValues="defaultEmailCcs"
                @formCcListUpdate="updateFormCcList"
            )

        //- technology-pixel
        //- https://github.com/baianat/vee-validate/issues/793
        div.section-technology.section-technology-pixel(v-if="technology === 'technology-pixel'")
            div.form-subsection
                div.form-label__required
                    label Pixel URL
                input.form-input(
                    id="pixel-url"
                    name="pixel-url"
                    placeholder="https://"
                    v-model="pixel_url"
                    v-validate="'url|max:255|required'"
                    type="text"
                )
                span.form-validate-error {{ errors.first('pixel-url') }}
            div.form-subsection-row.form-subsection-random-url.l-flex-row
                input(
                    type="checkbox"
                    name="random-url"
                    id="random-url"
                    v-model="transferData.randomParam"
                )
                label(for="random-url") Add random parameter
                    div.form-section-subtitle ? d.r=random

        //- technology-media
        //- device mode
        div.section-technology.section-technology-media(v-if="technology === 'technology-media'")
            //- DSP Segment ID
            div.form-subsection
                div.form-label
                    label Partner
                select.form-select.big(v-model="transferData.accountDspId" @change="changePartner($event)")
                    optgroup(v-for="group in dspDropDownList" :key="group.id" :label="group.label")
                        option(
                            v-for="item in group.options"
                            :key="item.id"
                            :value="item.id"
                            :title="item.label"
                            :data-partner="item.partnerKey") {{ item.transferLabel }}
                div.l-flex-row.message-warning(v-if="dspAdobe")
                    svg-icon(name='warning' size="small" title="warning")
                    | This partner requires a bootstrap 72 hours after transfer creation

            div.form-subsection
                div.form-section-device-mode
                    div.form-label
                        label Device mode
                    select.form-select.big.select-device-mode(v-if="desktopOnly" v-model="transferData.deviceMode" :disabled="dspSnapchat")
                        option(v-for="item in desktopOnlyDevice", :key="item.transferValue" :value="item.transferValue") {{ item.label }}
                    select.form-select.big.select-device-mode(v-else-if="!desktopOnly" v-model="transferData.deviceMode")
                        optgroup(v-for="group in volumes", :key="group.profile" :label="group.label")
                            option(v-for="item in group.options", :key="item.transferValue" :value="item.transferValue") {{ item.label }}


            template(
                v-if="selectedPartnerIsDDP"
            )
                div.form-subsection
                    div.form-label__required
                        label Reference ID
                    input(
                        class="l-flex-row form-input"
                        name="reference-id"
                        id="reference-id"
                        placeholder="Reference ID"
                        v-validate="'required|max:100|ascii'"
                        v-model="googleDDP.referenceId"
                    )
                    span.form-validate-error(v-if="errors.has('reference-id')") {{ errors.first('reference-id') }}
                div.form-subsection
                    div.form-label.form-label__required(:class="cpmRequired")
                        label CPM
                    input.form-input(
                        id="ddp-cpm"
                        name="ddp-cpm"
                        v-model="googleDDP.ddpCpm"
                        placeholder="ddp-cpm"
                        v-validate="'required|decimal:3|min_value:0|max_value:99.999'"
                        type="text"
                    )
                    span.form-validate-info(v-if="displayDDPCpmFieldInfo") Must be set with a float
                    span.form-validate-error(v-else) {{ errors.first('ddp-cpm') }}

            //- DSP SPECIFICS
            div.form-subsection(v-if="dspYandex")
                div.form-label
                    label Tariff
                el-select.select-transfer(
                    v-model="dsp_segment_id"
                    default-first-option
                    size='large'
                )
                    el-option(
                        v-for='tariff in 5'
                        :value='tariff'
                    ) {{tariff}}
            div(v-if="hasCpm || hasSegmentId")
                //- CPM
                div(v-if="hasCpm && dspTradedesk")
                    div.form-subsection
                        div.form-label.form-label__required(:class="cpmRequired")
                            label CPM Capping
                        input.form-input(
                            id="cpm"
                            name="cpm"
                            placeholder="Maximum Cost Per Mille impressions charged (e.g. 1.2)"
                            v-model="cpm"
                            v-validate="'decimal:7|min_value:0|max_value:1000|required'"
                            type="text"
                        )
                        span.form-validate-info(v-if="displayCpmFieldInfo") Must be set with a float
                        span.form-validate-error(v-else) {{ errors.first('cpm') }}

                    div.form-subsection
                        div.form-label.form-label__required
                            label Media Rate
                        input.form-input(
                            id="media-rate"
                            name="media-rate"
                            placeholder="Base charged delivery rate (on Buyer Media Cost, e.g. 0.8)"
                            v-model="mediaRate"
                            v-validate="'decimal:7|min_value:0|max_value:100|required'"
                            type="text"
                        )
                        span.form-validate-info(v-if="displayMediaRateFieldInfo") Must be set with a float
                        span.form-validate-error(v-else) {{ errors.first('media-rate') }}


                div.form-subsection(v-else-if="hasCpm")
                    div.form-label(:class="cpmRequired")
                        label CPM
                    input.form-input(
                        id="cpm"
                        name="cpm"
                        v-model="cpm"
                        v-validate="cpmCondition"
                        type="text"
                    )
                    span.form-validate-info(v-if="displayCpmFieldInfo && dspPubmatic") Set the value to 0 if the data is not billable. Note the value is in dollars
                    span.form-validate-info(v-else-if="displayCpmFieldInfo && !dspPubmatic") Must be set with a float
                    span.form-validate-error(v-else) {{ errors.first('cpm') }}


                //- Segment identifier
                div.form-subsection(v-if="hasSegmentId")
                    div.form-label__required
                        label Segment identifier
                    input.form-input(
                        id="segmentId"
                        name="segmentId"
                        v-model="dsp_segment_id"
                        v-validate="segmentIdCondition"
                        type="text"
                    )
                    span.form-validate-info(v-if="displaySegmentIdFieldInfo") {{ segmentIdFieldInfoText }}
                    span.form-validate-error(v-else) {{ errors.first('segmentId') }}

            //- Cookie Split
            div.form-section.form-section-cookie-split(v-if="displayCookieSplit")
                div.form-label
                    label Cookie split
                div.l-flex-column
                    range-slider(
                        v-model="transferData.cookieSplit"
                        range
                        :max='100'
                        :min='1'
                        :marks="{ '1': '1', '100': '100' }")
        //- Push of Stock
        div.form-section---bootstrap.form-section--push-of-stock(v-if="displayPushOfStock")
            div.form-label(:class="{ 'ui-disabled': disablePushOfStock }")
                label.flex-1(for="switch-bootstrap") Push of stock
                div.form-section-subtitle--bootstrap
                    | Activate the last 30 days of data
            div.onoffswitch(:class="{ 'ui-disabled': disablePushOfStock }")
                input(
                    id="switch-bootstrap"
                    name="switch-bootstrap"
                    class="onoffswitch-checkbox"
                    type="checkbox"
                    v-model="pushOfStockActivation"
                    unchecked
                )
                label(class="onoffswitch-label" for="switch-bootstrap")
        div.form-validate-error(v-if="disablePushOfStock && technology === 'technology-media'") The account daily quota has been reached or would be exceeded. Bootstrap will be available when the quota is reset.

    //- Footer transfer form
    footer.modal-footer
        div.footer-content.l-flex-row--between
            button.btn.btn--medium.btn--round(@click="closeFormTransfer()") Cancel
            button.btn.btn--medium.btn--round.btn-rev(:class="{'ui-disabled': disabledSaveButton}" @click="addTransfer()") {{ submitButtonText }}
</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import Vue from 'vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { DSP_KEY_LABELS, PIXEL_URL_RANDOM_PARAM, VOLUMES, UTIQ_VOLUMES } from '@/utils/constants'
import { size, isEmpty, last, includes, toString, toNumber, isNil, filter, get, head, split, trimEnd, isEqual, find, cloneDeep } from 'lodash'
import EmailCcField from '@/components/common/EmailCcField'
import RangeSlider from '@/components/common/RangeSlider'
import dayjs from 'dayjs'
import { getTokenUserEmail } from '@/utils/helpers'

export default {
    name: 'FormCreateTransfer',
    components: {
        EmailCcField,
        RangeSlider
    },
    props: {
        audienceLabel: { type: String, required: true },
        audienceEndDate: { type: Date, required: true },
        isFirstPartyInFormula: { type: Boolean, required: true },
        parent: { type: String, required: true },
        selectedAudience: { type: Object, required: false, default: () => ({}) }
    },

    data() {
        return {
            transferData: {
                url: '',
                label: '',
                accountDspId: null,
                deviceMode: 'Desktop identifier',
                cookieSplit: [1, 100],
                randomParam: false,
                end_date: null,
                email: getTokenUserEmail(Vue.prototype.$keycloak),
                email_cc: []
            },
            endDate: dayjs()
                .add(30, 'day')
                .valueOf(),
            pixel_url: '',
            technology: '',
            desktopOnlyDevice: [
                {
                    label: 'Cookie',
                    value: 'desktop',
                    transferValue: 'Desktop identifier'
                }
            ],
            cpm: '',
            mediaRate: '',
            dsp_segment_id: 1,
            pushOfStockActivation: false,
            processing: false,
            defaultEmailCcs: [],
            googleDDP: {
                referenceId: '',
                ddpCpm: null,
            },
        }
    },

    created() {
        this.isEdit ? this.setEditTransferData() : this.setDefaultTransferData()
        this.showMediaPlatformPanel ? (this.technology = 'technology-media') : (this.technology = 'technology-pixel')
        const dict = {
            custom: {
                'transfer-label': {
                    required: 'The value is mandatory and cannot be empty',
                    max: 'The value should contain less than 200 characters',
                    ascii: 'The value must contain ASCII charaters only'
                },
                'ddp-cpm': {
                    required: 'The value is mandatory and cannot be empty',
                    decimal: 'The  CPM field supports a maximum of 3 decimals',
                    regex: 'The value must be a number (use a dot for decimals)',
                    max_value: 'The maximum cpm value is 99.999'
                },
                'reference-id': {
                    required: 'The value is mandatory and cannot be empty',
                    max: 'The value should contain less than 100 characters',
                    ascii: 'The value must contain ASCII charaters only'
                },
                cpm: {
                    decimal: 'The  CPM Capping field supports a maximum of 7 decimals',
                    regex: 'The value must be a number (use a dot for decimals)',
                    max_value: 'The maximum cpm value is 1000'
                },
                'media-rate': {
                    decimal: 'The  Media Rate field supports a maximum of 7 decimals'
                },
                segmentId: {
                    alpha_num: 'The value can contain numbers and letters only',
                    integer: 'The value must be a positive integer'
                }
            }
        }
        this.$validator.localize('en', dict)
    },
    mounted() {
        // retrieve allocation counter for transfers push of stock (only in case when open from monitoring)
        if (this.parent === 'monitoring') this.retrieveAttributionCounterTransfer()
    },

    watch: {
        accountDspId: {
            handler: function(val, oldVal) {
                if (!isEqual(val, oldVal) && !this.isEdit) {
                    this.setTransferName(this.technology)
                }
            },
            deep: true
        },

        technology: {
            handler: function(val, oldVal) {
                if (!isEqual(val, oldVal) && !this.isEdit) {
                    this.setDefaultTransferData()
                    this.setTransferName(val)
                }
            }
        },

        desktopOnly: {
            handler(val, oldVal) {
                if (val && !isEqual(val, oldVal)) {
                    this.transferData.deviceMode = 'Desktop identifier'
                }
            }
        },

        isEdit: {
            handler: function(val, oldVal) {
                if (!isEqual(val, oldVal)) {
                    if (val) this.setEditTransferData()
                }
            }
        },

        endDate: {
            handler: function(val, oldVal) {
                if (!isEqual(val, oldVal)) {
                    this.setTransferEndDate({ endDate: val })
                }
            }
        },

        activeTabFormAudience: {
            handler: function(val) {
                if (val !== 'audienceTransfer' && this.isEdit) {
                    this.setTransferForm({ action: 'add', techno: this.transferInEdition.technology, transfer: this.transferInEdition })
                }
            }
        }
    },

    computed: {
        // Call mapState
        ...mapState('data/accountsDsps', {
            accountsDsps: state => state.list
        }),
        ...mapState('account', {
            attributionCounterTransfer: state => state.attributionCounterTransfer,
            dailyPushOfStockLimit: state => state.dailyPushOfStockLimit,
            userRole: state => state.userRole
        }),
        ...mapState('ui/settings', {
            bootstrapPush: state => state.general.bootstrapPush,
            providerFirstIdActivated: state => state.general.providerFirstIdActivated,
            providerUtiqActivated: state => state.general.providerUtiqActivated,
        }),
        ...mapState('ui/transfers', {
            isEdit: state => state.isEdit,
            transferInEdition: state => state.transferInEdition,
            transferForms: state => state.forms
        }),
        ...mapState('data/settings', {
            xdevice: state => state.general.xdevice
        }),

        ...mapState('ui/builder', {
            activeTabFormAudience: state => state.formAudience.activeTabFormAudience
        }),

        // Call mapGetters
        ...mapGetters('ui/transfers', ['getDsps']),
        ...mapGetters('data/accountsDsps', ['getAccountsDspById']),

        dspKeyLabels() {
            return DSP_KEY_LABELS
        },

        dspDropDownList() {
            return this.getDsps().filter((dsp) => {
                if ((dsp.keyLabel === 'gam' && !this.providerFirstIdActivated) || (dsp.keyLabel.includes('utiq') && !this.providerUtiqActivated)) return false
                if (dsp.keyLabel === 'tiktok') {
                    dsp.options = dsp.options.filter((option) => JSON.parse(option.extra_info).is_authenticated)
                }

                if (dsp.keyLabel === 'gam') {
                    dsp.label = 'Google GAM PPID'
                }
                return dsp.options.length > 0
            })
        },

        minDateLimit() {
            return dayjs()
                .startOf('day')
                .valueOf()
        },

        maxDateLimit() {
            return dayjs()
                .add(395, 'days')
                .startOf('day')
                .valueOf()
        },

        endDateOptions() {
            return {
                firstDayOfWeek: 1,
                disabledDate: time => {
                    return (
                        this.minDateLimit >
                            dayjs(time)
                                .startOf('day')
                                .valueOf() || dayjs(time).valueOf() >= this.maxDateLimit
                    )
                }
            }
        },

        totalPixelTransfers() {
            return size(this.transferForms['technology-pixel'])
        },

        totalMediaTransfers() {
            return size(this.transferForms['technology-media'])
        },

        totalTransfers() {
            return this.totalPixelTransfers + this.totalMediaTransfers
        },

        volumes() {
            const dsp = this.findDsp(['utiq_equativ', 'utiq_adform', 'gam'], this.accountDspId)
            const isUtiqDsp = ['utiq_equativ', 'utiq_adform'].includes(dsp?.partnerKey)

            let _volumes = []

            if (isUtiqDsp) {
                _volumes = cloneDeep(UTIQ_VOLUMES)
                if (!this.xdevice) {
                    _volumes = _volumes.splice(0, 1)
                }
                return _volumes
            }

            _volumes = cloneDeep(VOLUMES)

            if (!this.xdevice || this.dspTiktokEmailIdType) {
                _volumes = _volumes.splice(0, 1)
            }

            const dspIsGam = dsp?.partnerKey === 'gam'

            _volumes = _volumes.map((volume) => {
                if (volume.options) {
                    volume.options = volume.options.filter((_v) => {
                        if (dspIsGam && !_v.altId) return false
                        let keep = true

                        if (_v.visible) {
                            keep = _v.visible(dsp?.partnerKey)
                        }
                        if (_v.altId && keep) {
                            if (_v.altId === 'first-id') {
                                keep = this.providerFirstIdActivated
                            }
                        }
                        return keep
                    })
                }
                return volume
            })// findDsp

            return _volumes
        },

        displayCookieSplit() {
            return this.technology === 'technology-media'
        },

        cookieSplit() {
            return toString(this.transferData.cookieSplit[0] - 1) + '..' + toString(this.transferData.cookieSplit[1] - 1)
        },

        accountDspId() {
            return this.transferData.accountDspId
        },

        dspId() {
            const selectedAccountDsp = last(
                filter(this.accountsDsps, accountDsp => {
                    return accountDsp.id === this.accountDspId
                })
            )
            return isNil(selectedAccountDsp) ? null : selectedAccountDsp.dsp_id
        },

        desktopOnly() {
            const cookieOnlyKeyLabels = ['adventori', 'radiumone', 'yandex', 'snapchat'] //dsp\'key labels for dsp whose identifier type is on;y 'desktop identifier'
            for (const dsp of this.dspDropDownList) {
                for (const option of dsp.options) {
                    if (option.id === this.accountDspId && includes(cookieOnlyKeyLabels, dsp.keyLabel)) {
                        return true
                    }
                }
            }
            return false
        },

        showMediaPlatformPanel() {
            if (this.haveOnlyUtiq && !this.providerUtiqActivated) return false
            return ((!this.isEdit || (this.isEdit && this.technology === 'technology-media')) && !isEmpty(this.accountsDsps))
        },

        haveOnlyUtiq () {
            return this.accountsDsps.every((account) => ['utiq_equativ', 'utiq_adform'].includes(account.partnerKey))
        },

        showPixelUrlPanel() {
            return !this.isEdit || (this.isEdit && this.technology === 'technology-pixel')
        },

        selectedPartnerIsDDP() {
            const googledbm = this.dspDropDownList.find((dsp) => dsp.keyLabel === 'googledbm')
            if (googledbm) {
                const ddpPartner = googledbm.options.find((partner) => partner.id === this.transferData.accountDspId)
                return ddpPartner && ddpPartner.extra_info.trim() !== '' && ddpPartner.extra_info.length > 0
            }
            return false
        },

        disabledSaveButton() {
            const googleDDpCondition = !this.selectedPartnerIsDDP ? false : (
                this.errors.has('ddp-cpm') ||
                this.googleDDP.ddpCpm === 0 ||
                this.googleDDP.ddpCpm === null ||
                this.errors.has('reference-id') ||
                this.googleDDP.referenceId === ''
            )

            return (
                this.processing ||
                this.errors.has('email') ||
                this.totalTransfers > 10 ||
                this.isTransferAlreadyAdded ||
                this.errors.has('transfer label') ||
                this.transferData.label === '' ||
                isNil(this.endDate) ||
                this.errors.has('end_date') ||
                (this.technology === 'technology-media' && (this.errors.has('cpm') || (this.isCpmRequired && isEmpty(this.cpm)))) ||
                (this.technology === 'technology-media' && (this.errors.has('media-rate') || (this.isMediaRateRequired && isEmpty(this.mediaRate)))) ||
                (this.technology === 'technology-media' && (this.errors.has('segmentId') || (this.hasSegmentId && isEmpty(this.dsp_segment_id)))) ||
                (this.technology === 'technology-pixel' && (this.errors.has('pixel-url') || this.pixel_url === '')) ||
                googleDDpCondition
            )
        },

        submitButtonText() {
            return (this.isEdit ? 'Edit' : 'Add') + ' transfer'
        },

        selectedAccountsDsp() {
            return this.getAccountsDspById({ id: this.accountDspId })
        },

        dspAdobe() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.adobe
        },

        dspXander() {
            if (!isEmpty(get(this.selectedAccountsDsp, 'extra_info', ''))) {
                return (
                    get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.appNexus &&
                    JSON.parse(get(this.selectedAccountsDsp, 'extra_info', ''))['apx_clientid_type'] === 'advertiser_id'
                )
            }
            return false
        },

        dspCriteo() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.criteov2
        },

        dspGeneric() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.genericDsp
        },

        dspMediamath() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.mediamath
        },

        dspTradedesk() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.theTradeDesk
        },

        dspYandex() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.yandex
        },

        dspSnapchat() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.snapchat
        },

        dspZbo() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.zbo
        },

        dspPubmatic() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.pubmatic
        },

        dsp3rdParty() {
            return this.selectedAccountsDsp.transfer_type === '3rdparty'
        },

        dspTiktok() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.tiktok
        },

        dspSmartAdServer() {
            return get(this.selectedAccountsDsp, 'partnerKey', '') === this.dspKeyLabels.smartAdServer
        },

        dspTiktokEmailIdType() {
            return this.dspTiktok && JSON.parse(this.selectedAccountsDsp.extra_info).id_type === 'Email'
        },

        isCpmRequired() {
            return ((this.dspAdobe || this.dspTradedesk) && this.dsp3rdParty) || this.dspPubmatic
        },

        isMediaRateRequired() {
            return this.dspTradedesk && this.dsp3rdParty
        },

        hasCpm() {
            return this.isCpmRequired || this.dspGeneric  || this.dspSmartAdServer
        },

        cpmRequired() {
            return this.isCpmRequired ? 'form-label__required' : 'form-label'
        },

        cpmCondition() {
            return { required: !this.dspGeneric && !this.dspSmartAdServer, regex: /^\d*\.?\d*$/, decimal: '7', min_value: '0', max_value: '1000' }
        },

        hasSegmentId() {
            return this.dspXander || this.dspCriteo || this.dspMediamath || this.dspZbo
        },

        segmentIdCondition() {
            return this.dspZbo || this.dspCriteo ? 'alpha_num|max:200|required' : 'integer|min_value:0|max:200|required'
        },

        displayMediaRateFieldInfo() {
            return isEmpty(this.mediaRate) && !this.errors.has('media-rate')
        },

        displayCpmFieldInfo() {
            return isEmpty(this.cpm) && !this.errors.has('cpm')
        },

        displayDDPCpmFieldInfo() {
            return isEmpty(this.googleDDP.ddpCpm) && !this.errors.has('ddp-cpm')
        },

        displaySegmentIdFieldInfo() {
            return isEmpty(this.dsp_segment_id) && !this.errors.has('segmentId')
        },

        segmentIdFieldInfoText() {
            return this.displaySegmentIdFieldInfo && (this.dspZbo || this.dspCriteo) ? 'Must be set with an alphanumeric' : 'Must be set with an integer'
        },

        isTransferAlreadyAdded() {
            for (const technologies in this.transferForms) {
                for (const transfer of this.transferForms[technologies]) {
                    return transfer.label === this.transferData.label
                }
            }
            return false
        },

        disablePushOfStock() {
            if (this.technology !== 'technology-pixel') {
                if (this.userRole === 'webo_admin') return false
                return this.bootstrapPush && this.isPushOfStockQuotaExceeded
            }
            return true
        },

        displayPushOfStock() {
            if (this.parent === 'monitoring' && this.technology !== 'technology-pixel') {
                const { type } = this.selectedAudience
                if (this.userRole === 'webo_admin' || (this.bootstrapPush && this.userRole === 'webo_employee')) return true
                if (type === 'cclones' && this.bootstrapPush) return true
                if (this.bootstrapPush) return !this.selectedAudience?.isThirdParty
                return false
            }
            return false
        },

        isPushOfStockQuotaExceeded() {
            //checking if adding this current Volume would exceed daily push of stock limit
            if (this.parent === 'monitoring' && this.userRole !== 'webo_admin')
                return this.selectedAudience.volume + this.attributionCounterTransfer >= this.dailyPushOfStockLimit
            return false
        }
    },

    methods: {
        // Call mapMutations
        ...mapMutations('ui/transfers', [
            'setTransferForm',
            'setIsEditTransfer',
            'setTransferInEdition',
            'setShowFormCreateTransfer',
            'setDefaultTransferForm',
            'setTransferEndDate'
        ]),
        ...mapActions('account', ['retrieveAttributionCounterTransfer']),

        ...mapMutations('ui/builder', ['setActiveTabFormAudience']),

        // Transfer
        closeFormTransfer() {
            this.processing = false
            if (this.isEdit) {
                //if user closes form before saving edition, transfer is not deleted
                this.setTransferForm({ action: 'add', techno: this.transferInEdition.technology, transfer: this.transferInEdition })
            }
            if (this.parent === 'monitoring' && this.totalTransfers === 0) {
                this.setDefaultTransferForm()
            }
            this.resetTransferData()
        },

        setDefaultTransferData() {
            //set default data
            this.transferData.accountDspId = this.transferData.accountDspId || this.dspDropDownList?.[0]?.options?.[0]?.id
            const suffix = this.technology === 'technology-media' && this.selectedAccountsDsp?.label ? this.selectedAccountsDsp.label : 'Pixel URL'
            this.transferData.label = `${this.audienceLabel} - ${suffix}`
            this.transferData.end_date = dayjs(this.endDate).format('YYYY-MM-DD')
            this.setTransferEndDate({ endDate: this.endDate })
            this.changePartner()
        },

        setEditTransferData() {
            // clone object to avoid console error state outside mutation handlers
            const transferInEdition = { ...this.transferInEdition }
            //set data based on transferInEdition
            this.transferData.label = transferInEdition.label
            this.transferData.email = transferInEdition.email
            // to retrieve endDate of the edited transfer
            this.endDate = transferInEdition.end_date
            this.transferData.endDate = transferInEdition.end_date
            this.technology = transferInEdition.technology

            if (transferInEdition?.bootstrap === 'bootstrap') {
                this.transferData.bootstrap = transferInEdition.bootstrap
            } else {
                delete this.transferData?.bootstrap
            }
            if (transferInEdition?.bootstrap_status === 'pending') {
                this.transferData.bootstrap_status = transferInEdition.bootstrap_status
            } else {
                delete this.transferData?.bootstrap_status
            }
            if (this.transferData?.bootstrap_status === 'pending' && this.transferData?.bootstrap === 'bootstrap') {
                this.pushOfStockActivation = true
            }

            if (transferInEdition.dsp_segment_id) {
                this.dsp_segment_id = transferInEdition.dsp_segment_id
            }

            // Set the previously given cc to the email cc component
            this.defaultEmailCcs = transferInEdition.email_cc
            this.updateFormCcList(transferInEdition.email_cc)

            if (transferInEdition.reference_id) {
                this.googleDDP.referenceId = transferInEdition.reference_id
                this.googleDDP.ddpCpm = transferInEdition.cpm
            }

            if (transferInEdition.technology === 'technology-media') {
                const cookieSplit = split(transferInEdition.cookieSplit, '..')
                this.transferData.cookieSplit[0] = toNumber(head(cookieSplit)) + 1
                this.transferData.cookieSplit[1] = toNumber(last(cookieSplit)) + 1

                this.transferData.dspId = transferInEdition.dspId
                this.transferData.accountDspId = transferInEdition.accountDspId
                this.transferData.deviceMode = transferInEdition.deviceMode

                if (!isEmpty(transferInEdition.dsp_segment_id)) {
                    this.dsp_segment_id = transferInEdition.dsp_segment_id
                }
                if (!isEmpty(transferInEdition.cpm)) {
                    this.cpm = transferInEdition.cpm
                }
                if (!isEmpty(transferInEdition.media_rate)) {
                    this.mediaRate = transferInEdition.media_rate
                }
            } else if (transferInEdition.technology === 'technology-pixel') {
                if (transferInEdition.randomParam) {
                    const _randomParam = new RegExp(`[?&]${PIXEL_URL_RANDOM_PARAM}`, 'i')
                    const url = transferInEdition.url.replace(_randomParam, '')
                    this.pixel_url = trimEnd(url)
                } else {
                    this.pixel_url = transferInEdition.url
                }
                this.transferData.randomParam = transferInEdition.randomParam
            }
        },

        updateFormCcList(ccList) {
            this.transferData.email_cc = ccList
        },

        resetTransferData() {
            this.transferData = {
                url: '',
                label: '',
                accountDspId: null,
                deviceMode: 'Desktop identifier',
                cookieSplit: [1, 100],
                randomParam: false
            }
            this.endDate = new Date().setMonth(new Date().getMonth() + 1)
            this.technology = 'technology-media'
            this.pixel_url = ''
            this.cpm = ''
            this.mediaRate = ''
            this.dsp_segment_id = ''
            this.googleDDP.referenceId = ''
            this.googleDDP.cpm = null

            //on builder view keep transfer form open
            if (this.parent === 'builder') {
                this.setShowFormCreateTransfer({ show: false })
                if (this.isEdit) this.setActiveTabFormAudience({ tab: 'audienceTransfer' })
                else this.setActiveTabFormAudience({ tab: 'audienceDetails' })
            }
            //on audience monitoring view reset default data
            if (this.parent === 'monitoring') {
                this.setDefaultTransferData()
                this.setShowFormCreateTransfer({ show: false })
            }

            this.setIsEditTransfer({ isEdit: false })
            this.setTransferInEdition({ transfer: {} })
        },

        addTransfer() {
            if (this.processing) return // Prevent multiple creation
            this.processing = true
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        if (this.technology === 'technology-pixel') {
                            this.formatURL()
                            this.transferData.accountDspId = null
                        } else if (this.technology === 'technology-media') {
                            this.transferData.cookieSplit = this.cookieSplit
                            this.transferData.dspId = this.dspId
                            this.transferData.accountDspId = this.accountDspId
                            //- Extra info following chosen DSP
                            if (this.hasCpm && !isEmpty(this.cpm)) this.transferData.cpm = this.cpm
                            if (this.isMediaRateRequired && !isEmpty(this.mediaRate)) this.transferData.media_rate = this.mediaRate
                            if (this.dspYandex || this.hasSegmentId) this.transferData.dsp_segment_id = this.dsp_segment_id
                        }
                        // Push of stock
                        if (this.pushOfStockActivation) {
                            this.transferData.bootstrap = 'bootstrap'
                            this.transferData.bootstrap_status = 'pending'
                        } else {
                            delete this.transferData.bootstrap
                            delete this.transferData.bootstrap_status
                        }

                        if (this.selectedPartnerIsDDP) {
                            this.transferData.reference_id = this.googleDDP.referenceId
                            const cpm = this.googleDDP.ddpCpm.includes('.') ? this.googleDDP.ddpCpm : `${this.googleDDP.ddpCpm}.00`
                            this.transferData.cpm = cpm
                        } else {
                            delete this.transferData.reference_id
                            if (!(this.hasCpm || this.dspTradedesk)) {
                                delete this.transferData.cpm
                            }
                        }
                        //- Add technology info in transferData in case of edition
                        this.transferData.technology = this.technology
                        this.transferData.end_date = this.endDate
                        this.setTransferForm({ action: 'add', techno: this.technology, transfer: this.transferData })
                        if (this.parent === 'builder') {
                            this.setShowFormCreateTransfer({ show: false })
                            this.setActiveTabFormAudience({ tab: 'audienceTransfer' })
                            this.setIsEditTransfer({ isEdit: false })
                        } else this.resetTransferData()
                    }
                })
                .catch(() => {
                    this.closeFormTransfer()
                })
        },

        formatURL() {
            //add random param if box checked
            if (this.transferData.randomParam) {
                // check if URL already has params
                const _params = new URL(this.pixel_url).searchParams
                const params = []
                for (const value of _params.values()) {
                    params.push(value)
                }
                if (isEmpty(params)) {
                    this.transferData.url = this.pixel_url + '?' + PIXEL_URL_RANDOM_PARAM
                    //no params => add random as first param
                } else {
                    //params => random as last param
                    this.transferData.url = this.pixel_url + '&' + PIXEL_URL_RANDOM_PARAM
                }
            } else {
                this.transferData.url = this.pixel_url
            }
        },

        handleResetFieldOnLeave(field) {
            if (field === 'endDate' && this.errors.has('end_date')) this.endDate = this.audienceEndDate
            else if (field === 'email' && this.errors.has('email')) this.transferData.email = getTokenUserEmail(Vue.prototype.$keycloak)
            else if (field === 'label' && this.errors.has('transfer label')) {
                const suffix = this.technology === 'technology-media' ? this.selectedAccountsDsp.label : 'Pixel URL'
                this.transferData.label = `${this.audienceLabel} - ${suffix}`
            }
        },

        isLabelUnchanged(criteria, previousDsp) {
            if (criteria === 'dsp') {
                if (isNil(previousDsp)) return true
                const selectedDsp = find(this.accountsDsps, item => toNumber(item.id) === toNumber(previousDsp))
                return (
                    this.transferData.label === this.audienceLabel + ' - ' + selectedDsp.label ||
                    this.transferData.label === this.audienceLabel + ' - Pixel URL'
                )
            } else {
                return (
                    this.transferData.label === this.audienceLabel + ' - ' + this.selectedAccountsDsp?.label ||
                    this.transferData.label === this.audienceLabel + ' - Pixel URL'
                )
            }
        },

        setTransferName(tab) {
            if (tab === 'technology-media') {
                this.transferData.label = `${this.audienceLabel} - ${this.selectedAccountsDsp?.label}`
            } else {
                this.transferData.label = `${this.audienceLabel} - Pixel URL`
            }
        },

        changePartner(event) {
            if (event) {
                const selectedOpt = event.target?.selectedOptions ? event.target?.selectedOptions[0] : {}
                if (selectedOpt) {
                    if (['utiq_equativ', 'utiq_adform'].includes(selectedOpt.dataset?.partner)) {
                        this.transferData.deviceMode = 'Utiq mobile identifier'
                        return
                    }
                }
            }
            const utiqPartners = this.dspDropDownList.every(({ keyLabel }) => ['utiq_equativ', 'utiq_adform'].includes(keyLabel))
            if (utiqPartners) {
                this.transferData.deviceMode = 'Utiq mobile identifier'
                return
            }
            const optionsVolume = VOLUMES[0].options.map((option) => option.transferValue)
            const dsp = this.findDsp(['gam'], this.transferData.accountDspId)
            if (dsp) {
                this.transferData.deviceMode = 'First-ID identifier'
            }
            if (this.dspTiktok && !optionsVolume.includes(this.transferData.deviceMode) || (!dsp && !this.dspTiktok)) {
                this.transferData.deviceMode = optionsVolume[0]
            }
        },

        findDsp(keys, id) {
            const _dsps = this.dspDropDownList.filter((dsp) => keys.includes(dsp.keyLabel))

            if (_dsps) {
                let _dsp = null
                _dsps.forEach(({ options }) => {
                    if (!_dsp) {
                        _dsp = options.find((partner) => partner.id === id)
                    }
                })
                return _dsp
            }
            return null
        },
    }
}
</script>
